$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function initApolloTopNav() {
	$('.apollo-episode-template [data-apollo-top-nav-toggle]').on('click', function () {
		var $toggle = $(this);
		var controlsId = $toggle.attr('aria-controls');
		var $menu = controlsId ? $('#' + controlsId) : $toggle.siblings('.topmenu_list').first();
		var isOpen = $menu.hasClass('is-open');

		$menu.toggleClass('is-open', !isOpen);
		$toggle.toggleClass('active', !isOpen);
		$toggle.attr('aria-expanded', !isOpen ? 'true' : 'false');
	});
}

$(document).ready(() => {
	initApolloTopNav();

	$('.carousel').each(function(){
		var $this = this;
		$(this).attr({
			role: 'region',
			'aria-roledescription': 'carousel'
		});
		$(this).slick({
			autoplay: false,
			adaptiveHeight: false,
			waitForAnimate: true,
			arrows: false,
			dots: true,
			infinite: false,
			fade: false,
			mobileFirst: true,
			touchThreshold: 4,
			initialSlide: 0,
			appendDots: $('.content',$this),
			prevArrow: '<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 25 32"><path class="path1" d="M17.99 1.79l-15.953 14.21 15.953 14.211c0.391 0.246 0.526 0.791 0.299 1.217s-0.727 0.572-1.118 0.327l-16.756-14.928c-0.254-0.16-0.385-0.447-0.394-0.744-0.005-0.028-0.004-0.054-0.006-0.083 0.002-0.028 0.001-0.054 0.005-0.083 0.009-0.297 0.14-0.585 0.394-0.745l16.756-14.925c0.392-0.246 0.892-0.1 1.118 0.326s0.092 0.971-0.299 1.217z"></path></svg></span>',
			nextArrow: '<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 25 32"><path class="path1" d="M18.516 16c-0.002 0.028-0.001 0.054-0.005 0.083-0.009 0.297-0.14 0.585-0.394 0.744l-16.757 14.927c-0.392 0.246-0.892 0.1-1.118-0.327s-0.092-0.971 0.299-1.217l15.953-14.21-15.953-14.21c-0.392-0.246-0.525-0.792-0.3-1.217s0.727-0.572 1.118-0.326l16.757 14.926c0.254 0.16 0.385 0.448 0.394 0.745 0.004 0.028 0.004 0.053 0.006 0.082z"></path></svg></span>',
			responsive: [
			    {
					breakpoint: 1024,
					settings: {
						arrows: true,
						dots: true,
						appendDots: $(this)
					}
			    }
			]
		});
	})

	$('.carousel').on('afterChange',function(event, slick, currentSlide){
		$(this).find('.slick-dots').each(function(){
			$('li',this).removeClass('slick-active');
			$('li',this).eq(currentSlide).addClass('slick-active');
		})
	})

	var apolloLineScrollFrame = null;

	$(window).on('load resize scroll', function() {
		if (!$('.apollo-episode-template').length) {
			return false;
		}

		if (apolloLineScrollFrame) {
			return false;
		}

		apolloLineScrollFrame = window.requestAnimationFrame(function () {
			apolloLineScrollFrame = null;

			$('.vertical-border,.vertical-border-top,.vertical-border-bottom').each(function(){
				var $line = $('.vertical-line', this);
				if (!$line.length || $line.data('apolloAnimated')) {
					return;
				}

				if ($line.isInViewport()) {
					var $height = $(this).height();
					$line.data('apolloAnimated', true);
					$line.animate({height: $height}, 1500, 'swing');
				}
			});
		});
	});
	
	if ($(window).width() > 768) {
		$('.apollo-episode-template section.apollo11-50th-anniversary  > *').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template section.world-witnessed .rte').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template .image_with_text').each(function(){
			if ($(this).hasClass('right-align')) {
				$('.content-image',this).attr('data-aos','fade-left');
				$('.content-text',this).attr('data-aos','fade-right');
				
			}else{
				$('.content-image',this).attr('data-aos','fade-right');
				$('.content-text',this).attr('data-aos','fade-left');
			}
		})
		$('.apollo-episode-template section.image_with_text_overlay').each(function(){
			if ($(this).hasClass('right-align')) {
				$('.hero__inner',this).attr('data-aos','fade-right');
				$('.hero-background > div',this).attr('data-aos','fade-left');
				
			}else{
				$('.hero__inner',this).attr('data-aos','fade-left');
				$('.hero-background > div',this).attr('data-aos','fade-right');
			}
		})
		$('.apollo-episode-template .apollo-episode-hero .apollo--media').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template section.video_and_image').each(function(){
			$('.video_container',this).attr('data-aos','fade-right');
			$('img',this).attr('data-aos','fade-left');
		})

		$('.apollo-episode-template section.carousel-section .content-inner').attr('data-aos','fade-left');
		$('.apollo-episode-template section.carousel-section .image').attr('data-aos','fade-right');
		$('.apollo-episode-template section.content_with_image .content-wrap > *').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template section.apollo-paginations .previous').attr('data-aos','fade-right');
		$('.apollo-episode-template section.apollo-paginations .next').attr('data-aos','fade-left');

		$('.apollo-landing-template section.image_with_text').each(function(){
			var height = parseInt( $('.content-text-inner',this).outerHeight() );
			$('.bg_hover',this).css('height', height);
		})
	}else{
		$('.apollo-episode-template section.apollo11-50th-anniversary  > *').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template section.world-witnessed .rte').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template .image_with_text').each(function(){
			$('.content-image',this).attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
			$('.content-text',this).attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		})
		$('.apollo-episode-template section.image_with_text_overlay').each(function(){
			$('.hero__inner',this).attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
			$('.hero-background > div',this).attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
				
		})
		$('.apollo-episode-template .apollo-episode-hero .apollo--media').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template section.video_and_image').each(function(){
			$('.video_container',this).attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
			$('img',this).attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		})

		$('.apollo-episode-template section.carousel-section .content-inner').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template section.carousel-section .image').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template section.content_with_image .content-wrap > *').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template section.apollo-paginations .previous').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
		$('.apollo-episode-template section.apollo-paginations .next').attr({'data-aos':'fade-up','data-aos-anchor-placement':'center-bottom'});
	}
	
	AOS.init({
		disable: false,
		mirror: false,
		delay: 100,
		easing: 'ease',
		duration: 1000
	});

	$('.apollo-episode-template .image_with_text .content-wrap').on('mouseenter',function(){
		$(this).addClass('hover');
		$(this).closest('.image_with_text').addClass('hover');
	})
	.on('mouseleave',function(){
		$(this).removeClass('hover');
		$(this).closest('.image_with_text').removeClass('hover');
	})
})